// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__awvm8","empty":"ModalGraph_empty__19di-"};